import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  text?: string
  className?: any
  textClassName?: any
  dataTestId?: string
}

const ChipComponent = ({ text, className, textClassName, dataTestId }: Props) => (
  <div
    css={[
      tw`inline-flex items-center justify-center px-2 py-0.5 rounded-[10px] bg-[#EDEDED]`,
      className,
    ]}
    {...(dataTestId ? { 'data-testid': dataTestId } : {})}
  >
    <Typography variant="subtitle2" css={textClassName}>
      {text}
    </Typography>
  </div>
)

export const Chip = memo(ChipComponent)
